import dates from './dates'

const countTrue = array => array.reduce((n, x) => n + (!!x === true), 0)

const handleListDates = ({ items, attr = 'at', format }) =>
  items.map(item => ({ ...item, [attr]: dates.format(item[attr], format) }))

export default { countTrue, handleListDates }
